const gtmLoginError = () => {
    dataLayer.push({
        event: 'login',
        step: 'login_error',
        _clear: true,
    })
}

export default gtmLoginError
